export const general_articles = [
    {
    "image_url": "https://www.columbiaspectator.com/resizer/v2/2KNXQ3K6RBHQ5D2IZ3JSW2YQH4.JPG?auth=0637b7acbdcbd8576cd6d5b966dcf0378e5ced478c2c64bd49ee5dbb1e53927e",
    "article_title": "Fink: NIL collectives and athlete compensation could threaten the future of Ivy League men’s hoops",
    "article_authors": "Nicholas Fink",
    "article_link": "https://www.columbiaspectator.com/sports/2025/01/20/fink-nil-collectives-and-athlete-compensation-could-threaten-the-future-of-ivy-league-mens-hoops/"
    }
];